module.exports = __webpack_public_path__ + "img/wallet.d7aaa159.png";